/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_User_Detail_Matching_Week_Admin_LabelInputs */

const en_admin_user_detail_matching_week_admin_label = /** @type {(inputs: Admin_User_Detail_Matching_Week_Admin_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matching Week admin`)
};

const de_admin_user_detail_matching_week_admin_label = /** @type {(inputs: Admin_User_Detail_Matching_Week_Admin_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matching Week Admin`)
};

/**
* | output |
* | --- |
* | "Matching Week admin" |
*
* @param {Admin_User_Detail_Matching_Week_Admin_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_user_detail_matching_week_admin_label = /** @type {((inputs?: Admin_User_Detail_Matching_Week_Admin_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_User_Detail_Matching_Week_Admin_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_user_detail_matching_week_admin_label(inputs)
	return en_admin_user_detail_matching_week_admin_label(inputs)
});